export const Feedback = {
  "Feedback": "Feedback",
  "Title": "Your voice is very important to us",
  "SummaryRequired": "Please enter a summary",
  "DescriptionRequired": "Please enter a description",
  "UploadFile": "Upload File",
  "UploadFileIntroduce": "Number of files must be no more than 3, Max file size is 8 MB, and allowed file types: jpeg, jpx, jpg, bmp, png, gif, tiff, tif, pdf, doc, docx, txt.",
  "Summary": "Summary",
  "Description": "Description",
  "Email": "Email",
  "Upload": "Upload",
  "ImageVerification": "Image Verification",
  "FileOverSize": "The file size cannot exceed 8 MB.",
  "ExeFileNotAllow": ".exe files cannot be uploaded.",
  "FileNumOver": "No more than 3 files may be uploaded.",
  "Submit": "Submit",
  "VerifyCodeError": "Verification code error",
  "VerifyCodeRequired": "Please input your verification code.",
  "NotValidEmail": "This is not a valid email address.",
  "uploadSuccess": "Upload success",
  "SubmitFeedbackTitle": "Submit feedback",
  "SubmitSuccessContent": "Your comment has been submitted. Thank you for making our service better!",
  "SubmitSuccessTitle": "Submitted successfully",
  "SubmitSuccessClose": "Close",
  "linkToHelpCenter": "Have more questions? Please go to the <span class=\"ToHelpCenter\">Help Center</span> for more support."
}